// Ghi lại NHANSU.TỔ từ Phân bổ nhân sự, như syncEmployeeTeamCache của V2. Gọi sau mọi lần sửa phân bổ
// (thêm, sửa, xóa, ghép Số HĐ) và từ nút "Đồng bộ tổ" ở màn Nhân sự, để hai bên không lệch nhau nữa.
import { planEmployeeTeamSync } from '../core/periodInputs';
import { payrollRepos } from './tables';

/** Trả về các người đã đổi tổ: [{ SO_HD, HO_TEN, from, TO }]. */
export async function syncEmployeeTeams(at = new Date()) {
    const [employees, allocations] = await Promise.all([payrollRepos.employees.list(), payrollRepos.allocations.list()]);
    const changes = planEmployeeTeamSync(employees, allocations, at);
    if (changes.length) await payrollRepos.employees.update(changes.map((change) => ({ SO_HD: change.SO_HD, TO: change.TO })));
    return changes;
}
